import { ComponentStatus } from '@christies/react/typings'
import { SitecoreContextReactContext } from '@sitecore-jss/sitecore-jss-react'
import React, { useEffect } from 'react'

type Data<T> = { status: ComponentStatus; data?: T }

export const useMockData = <T>(mockPromise: Promise<{ default: T }>): Data<T> => {
  const {
    context: { pageEditing },
  } = React.useContext(SitecoreContextReactContext)

  const [data, setData] = React.useState<Data<T>>({
    status: pageEditing ? 'initial' : 'error',
  })

  useEffect(() => {
    if (pageEditing) {
      mockPromise
        .then((mock) => {
          setData({ data: mock.default, status: 'ready' })
        })
        .catch(() => {
          setData({ status: 'error' })
        })
    }
  }, [])

  return data
}
